// extracted by mini-css-extract-plugin
export default {"container":"CardGridArea_container__-jsMQ","grid":"CardGridArea_grid__ATi5b","heading":"CardGridArea_heading__5tUTz"};